import { GridColumnType } from "../../../../components/molGrid/libs/data/gridColumnType";

export const clientsGridConfig = {
  isRowSelectable: true,
  allowEdit: false,
  hasChildGridTable: false,
  columns: [
    {
      name: "Client Name",
      fieldName: "clientName",
      colStyle: {
        textAlign: "left",
        width: "60%",
      },
      allowShort: true,
    },
    {
      name: "EIN",
      fieldName: "ein",
      colStyle: {
        textAlign: "left",
        width: "20%",
      },
      allowShort: true,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.TOGGLE,
      colSettings: {
        isChecked: true,
        isDisabled: false,
      },
      colStyle: {
        textAlign: "center",
        justifyContent:"center",
        width: "10%",
      },
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
            name: "VIEW",
            iconClass: 'lsicon:view-outline',
        },
    ],
      colStyle: {
        width: "10%",
      },
      allowShort: false,
    },
  ],
};
